import { initialSignalTranslationState } from './initialState';

import {
  SIGNALTRANSLATION_ERROR,
  GET_ALL_SIGNALTRANSLATION_DETAILS,
  SIGNALTRANSLATION_IS_LOADING,
  SET_SIGNALTRANSLATION_CURRENT_PAGE,
  SET_SIGNALTRANSLATION_PAGE_FILTER,
  SET_SIGNALTRANSLATION_CHANGE,
  SET_SIGNALTRANSLATION,
  UPDATE_SIGNALTRANSLATION_SAVE_STATUS,
  SET_SIGNALTRANSLATION_RESULT_CHANGE,
  SET_SIGNALTRANSLATION_CONSTANT_CHANGE,
  SET_SIGNALTRANSLATION_COMMENT_CHANGE,
  SIGNALTRANSLATION_VIEW_STATUS,
  SET_SIGNALTRANSLATION_CONST
} from '../constants/index';

const signalTranslationReducer = (state = initialSignalTranslationState, action) => {
  const { payload, type } = action;

  switch (type) {
    case GET_ALL_SIGNALTRANSLATION_DETAILS: {
      const { data } = payload;
      return {
        ...state,
        signalTranslation: {
          ...state.signalTranslation,
          ...data
        }
      };
    }

    case SET_SIGNALTRANSLATION_CURRENT_PAGE: {
      const { currentPage } = payload;
      return {
        ...state,
        signalTranslation: {
          ...state.signalTranslation,
          currentPage
        }
      };
    }

    case SET_SIGNALTRANSLATION_PAGE_FILTER: {
      const { filter } = payload;
      return {
        ...state,
        signalTranslation: {
          ...state.signalTranslation,
          filter
        }
      };
    }

    case UPDATE_SIGNALTRANSLATION_SAVE_STATUS: {
      const { data } = payload;
      return {
        ...state,
        signalTranslation: {
          ...state.signalTranslation,
          ...data
        }
      };
    }

    case SIGNALTRANSLATION_IS_LOADING: {
      const { isLoading } = payload;
      return {
        ...state,
        signalTranslation: {
          ...state.signalTranslation,
          isLoading: isLoading
        }
      };
    }

    case SIGNALTRANSLATION_ERROR: {
      const { data } = payload;
      return {
        ...state,
        signalTranslation: {
          ...state.signalTranslation,
          ...data
        }
      };
    }

    case SET_SIGNALTRANSLATION: {
      let { SelectedSignalTranslation, isOpSuccessful, showBanner } = payload;

      return {
        ...state,
        signalTranslation: {
          ...state.signalTranslation,
          SelectedSignalTranslation: {
            ...state.signalTranslation.SelectedSignalTranslation,
            ...SelectedSignalTranslation
          },
          isOpSuccessful: isOpSuccessful,
          showBanner: showBanner
        }
      };
    }

    case SET_SIGNALTRANSLATION_CONST: {
      let data = payload;

      return {
        ...state,
        signalTranslation: {
          ...state.signalTranslation,
          SelectedSignalTranslation: {
            ...state.signalTranslation.SelectedSignalTranslation,
            ...data
          },
          isOpSuccessful: false,
          showBanner: false
        }
      };
    }

    case SET_SIGNALTRANSLATION_CHANGE: {
      let { SelectedSignalTranslation } = payload;

      return {
        ...state,
        signalTranslation: {
          ...state.signalTranslation,
          SelectedSignalTranslation: {
            ...state.signalTranslation.SelectedSignalTranslation,
            ...SelectedSignalTranslation
          }
        }
      };
    }

    case SET_SIGNALTRANSLATION_RESULT_CHANGE: {
      let { SignalTranslationResults } = payload;

      return {
        ...state,
        signalTranslation: {
          ...state.signalTranslation,
          SelectedSignalTranslation: {
            ...state.signalTranslation.SelectedSignalTranslation,
            SignalTranslationResults: SignalTranslationResults
          }
        }
      };
    }

    case SET_SIGNALTRANSLATION_CONSTANT_CHANGE: {
      let { SignalTranslationComponentConstants } = payload;

      return {
        ...state,
        signalTranslation: {
          ...state.signalTranslation,
          SelectedSignalTranslation: {
            ...state.signalTranslation.SelectedSignalTranslation,
            SignalTranslationComponentConstants: SignalTranslationComponentConstants
          }
        }
      };
    }

    case SET_SIGNALTRANSLATION_COMMENT_CHANGE: {
      let { SignalTranslationComments } = payload;

      return {
        ...state,
        signalTranslation: {
          ...state.signalTranslation,
          SelectedSignalTranslation: {
            ...state.signalTranslation.SelectedSignalTranslation,
            SignalTranslationComments: SignalTranslationComments
          }
        }
      };
    }

    case SIGNALTRANSLATION_VIEW_STATUS: {
      const { status } = payload;
      return {
        ...state,
        signalTranslation: {
          ...state.signalTranslation,
          isViewMode: status
        }
      };
    }

    default:
      return state;
  }
};

export default signalTranslationReducer;
